import React, { useEffect } from 'react';

const CoasterGallery = () => {
  useEffect(() => {
    // Redirect to the static HTML file
    window.location.href = '/coasters-gallery.html';
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh',
      background: '#FEF7ED'
    }}>
      <p>Loading gallery...</p>
    </div>
  );
};

export default CoasterGallery;
